/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ integer: NonNullable<unknown>, decimal: NonNullable<unknown> }} Common_Validation_DecimalInputs */

const en_common_validation_decimal = /** @type {(inputs: Common_Validation_DecimalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Please enter no more than ${i?.integer} digits in the integer part and ${i?.decimal} digits in the decimal part`)
};

const ja_common_validation_decimal = /** @type {(inputs: Common_Validation_DecimalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`整数${i?.integer}桁、小数${i?.decimal}桁以内で入力してください`)
};

/**
* | output |
* | --- |
* | "Please enter no more than {integer} digits in the integer part and {decimal} digits in the decimal part" |
*
* @param {Common_Validation_DecimalInputs} inputs
* @param {{ locale?: "en" | "ja" }} options
* @returns {LocalizedString}
*/
export const common_validation_decimal = /** @type {((inputs: Common_Validation_DecimalInputs, options?: { locale?: "en" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Validation_DecimalInputs, { locale?: "en" | "ja" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_validation_decimal(inputs)
	return ja_common_validation_decimal(inputs)
});